export enum MEASUREMENT_TYPE {
    STATEFUL = 'stateful',
    METERED = 'metered',
}

export enum AGGREGATION_TYPE {
    TIME_WEIGHTED = 'time_weighted',
    END_OF_PERIOD = 'end_of_period',
    MAX_IN_PERIOD = 'max_in_period',
    COUNT = 'count',
    SUM = 'sum',
    MAX = 'max',
    LATEST = 'latest',
    /**
     * Present in the schema enum but always rejected with `400 unsupported_aggregation`
     * ("requires event ingestion"). Deliberately absent from VALID_AGGREGATIONS_BY_MEASUREMENT so it
     * can never be picked.
     */
    UNIQUE_COUNT = 'unique_count',
}

export type BillableMetric = {
    id: string;
    created_at: string;
    modified_at: string;
    name: string;
    code: string;
    measurement_type: MEASUREMENT_TYPE;
    aggregation_type: AGGREGATION_TYPE;
    description: string | null;
    /** Reserved for event ingestion, read by nothing. Never shown in the form. */
    field_name: string | null;
    /** Reserved for per-dimension metrics, read by nothing. Never shown in the form. */
    filters: unknown | null;
    is_active: boolean | null;
    /** UUID. The metric's natural unit - does NOT override the plan item's unit on invoices. */
    unit: string | null;
};
